module.exports = __webpack_public_path__ + "static/img/tutorial-normal-competitiveness-3.f56b016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tutorial-normal-competitiveness-3.jpg
// module id = 4ymT
// module chunks = 3